import React, { useEffect, useState } from 'react';
import { Modal, Backdrop, Fade, Menu, MenuItem, FormControl, InputLabel, Button, IconButton, Checkbox, ListItemText, Select, Input } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import theme from '../../../../app/config/themaConfig';

const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    modalProperties: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '50%',
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        borderRadius: '10px',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        position: 'relative',
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        width: '60%',
    },
    closeIcon: {
        position: 'absolute',
        top: theme.spacing(1),
        right: theme.spacing(1),
        cursor: 'pointer',
        color: theme.palette.primary.main,
    },
    centeredContent: {
        display: 'flex',
        alignItems: 'center',
        width: '50%',
    },
}));
const FilterModal = ({ open, handleClose, handleSelectGroup, ArrayEvbis,
    setSelectedEvbis, setSelectedFilters, selectedFilters, selectedEvbis, genero, setGenero,
    alturaMinima, setAlturaMinima, alturaMaxima, setAlturaMaxima, edadMinima, setEdadMinima,
    edadMaxima, setEdadMaxima, pesoMinimo, setPesoMinimo, pesoMaximo,
    setPesoMaximo, IMC, setIMC, PGC, setPGC, presion, setPresion,
    setSelectedEvbisNames,Evbisiniciales }) => {

    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);
    const [menuevbi, setMenuEvbi] = useState(null);
    const [selectedFiltertemp, setSelectedFiltertemp] = useState(selectedFilters);
    const [selectedEvbisTemp, setSelectedEvbisTemp] = useState(selectedEvbis === Evbisiniciales ? [] : selectedEvbis);
    const [selectedEvbisTempnames, setSelectedEvbisTempnames] = useState('');
    const [generoTemp, setGeneroTemp] = useState(genero);
    const [alturaMinimaTemp, setAlturaMinimaTemp] = useState(alturaMinima);
    const [alturaMaximaTemp, setAlturaMaximaTemp] = useState(alturaMaxima);
    const [edadMinimaTemp, setEdadMinimaTemp] = useState(edadMinima);
    const [edadMaximaTemp, setEdadMaximaTemp] = useState(edadMaxima);
    const [pesoMinimoTemp, setPesoMinimoTemp] = useState(pesoMinimo);
    const [pesoMaximoTemp, setPesoMaximoTemp] = useState(pesoMaximo);
    const [IMCTemp, setIMCTemp] = useState(IMC);
    const [PGCTemp, setPGCTemp] = useState(PGC);
    const [presionTemp, setPresionTemp] = useState(presion);
    const [hasChanges, setHasChanges] = useState(false);
    useEffect(() => {
        // Verificar si selectedEvbis es diferente de Evbisiniciales
        if (JSON.stringify(selectedEvbis) !== JSON.stringify(Evbisiniciales)) {
            setSelectedEvbisTemp(selectedEvbis);
        } else {
            setSelectedEvbisTemp([]);
        }
    }, [selectedEvbis, Evbisiniciales]);

    const primaryColor = theme.palette.primary.main;

    const handleOpenMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleCloseMenu = () => {
        setAnchorEl(null);
    };
    const handleOpenMenuEvbi = (event) => {
        setMenuEvbi(event.currentTarget);
    };
    const handleCloseMenuEvbi = () => {
        setMenuEvbi(null);
    };

    const handleSelectEvbi = (selectedIds) => {
        setSelectedEvbisTemp(selectedIds);
        const selectedNames = selectedIds.map(id => ArrayEvbis.find(evbi => evbi.id === id).name).join(', ');
        setSelectedEvbisTempnames(selectedNames);
    };

    const handleSelectFilters = (filters) => {
        setSelectedFiltertemp(filters);
    };

const handleFiltrar = () => {
    // Verificar que al menos una Evbi esté seleccionada
    if (selectedEvbisTemp.length === 0) {
        alert('Debe seleccionar al menos una Evbi.');
        return;
    }

    // Aplicar los cambios
    setSelectedEvbis(selectedEvbisTemp);
    setGenero(generoTemp);
    setAlturaMinima(alturaMinimaTemp);
    setAlturaMaxima(alturaMaximaTemp);
    setEdadMinima(edadMinimaTemp);
    setEdadMaxima(edadMaximaTemp);
    setPesoMinimo(pesoMinimoTemp);
    setPesoMaximo(pesoMaximoTemp);
    setIMC(IMCTemp);
    setPGC(PGCTemp);
    setPresion(presionTemp);
    handleClose();
    setSelectedEvbisNames(selectedEvbisTempnames)
    setSelectedFilters(selectedFiltertemp)
};
    const Generos = [
        { value: 'F', name: 'Femenino' },
        { value: 'M', name: 'Masculino' },
        { value: '-', name: 'Todos' },
    ];
    const IMCS = [
        { value: 3, name: 'Bajo' },
        { value: 4, name: 'Normal' },
        { value: 5, name: 'Sobre peso' },
        { value: 6, name: 'Obesidad clase l' },
        { value: 7, name: 'Obesidad clase ll' },
        { value: 8, name: 'Obesidad clase lll' },

    ];
    const PGCS = [
        { value: 9, name: 'Bajo' },
        { value: 10, name: 'Normal' },
        { value: 11, name: 'Alto' },
        { value: 12, name: 'Muy alto' },


    ];
    const Presiones = [
        { value: 13, name: 'Hipotension' },
        { value: 14, name: 'Optima' },
        { value: 15, name: 'Normal' },
        { value: 16, name: 'Sospecha' },
        { value: 17, name: 'Hipertension arterial' },

    ];

    let content = null;
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (anchorEl && !anchorEl.contains(event.target)) {
                handleCloseMenu();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [anchorEl, handleCloseMenu]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuevbi && !menuevbi.contains(event.target)) {
                handleCloseMenuEvbi();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [menuevbi, handleCloseMenuEvbi]);
    const handleClosed = () => {
        if (hasChanges) {
            const confirmClose = window.confirm('¿Estás seguro de que deseas cerrar sin aplicar los cambios?');
            if (confirmClose) {
                setSelectedFilters([]);
                setSelectedEvbis([]);
                setGenero('');
                setAlturaMinima(0);
                setAlturaMaxima(0);
                setEdadMinima(0);
                setEdadMaxima(0);
                setPesoMinimo(0);
                setPesoMaximo(0);
                setIMC('-');
                setPGC('-');
                setPresion('-');
                setSelectedEvbisNames('');
                handleClose();
            }
        } else {
            handleClose();
        }
    };

    useEffect(() => {
        setHasChanges(true);
    }, [selectedFiltertemp, selectedEvbisTemp, generoTemp, alturaMinimaTemp, alturaMaximaTemp, edadMinimaTemp, edadMaximaTemp, pesoMinimoTemp, pesoMaximoTemp, IMCTemp, PGCTemp, presionTemp]);
    useEffect(() => {
        setSelectedFiltertemp(selectedFilters)
        setSelectedEvbisTemp(selectedEvbis === Evbisiniciales ? [] : selectedEvbis)
        setGeneroTemp(genero);
        setAlturaMinimaTemp(alturaMinima);
        setAlturaMaximaTemp(alturaMaxima);
        setEdadMinimaTemp(edadMinima);
        setEdadMaximaTemp(edadMaxima);
        setPesoMinimoTemp(pesoMinimo);
        setPesoMaximoTemp(pesoMaximo);
        setIMCTemp(IMC);
        setPGCTemp(PGC);
        setPresionTemp(presion);

    }, [selectedEvbis, genero, alturaMinima, alturaMaxima, edadMinima, edadMaxima, pesoMinimo, pesoMaximo, IMC, PGC, presion,selectedFilters]);

    content = (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '9%', }}>
                {selectedFiltertemp.includes('Evbi') && (
                    <FormControl className={classes.formControl} style={{ width: '100%', borderRadius: '10px' }}>
                        <InputLabel id="genero-select-label-templates">Evbi</InputLabel>
                        <Select
                            multiple
                            id="filter-menu"
                            value={selectedEvbisTemp}
                            onChange={(e) => handleSelectEvbi(e.target.value)}
                            renderValue={(selected) => selected.map(id => ArrayEvbis.find(evbi => evbi.id === id).name).join(', ')}
                            MenuProps={{
                                anchorOrigin: {
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                },
                                transformOrigin: {
                                    vertical: 'top',
                                    horizontal: 'left',
                                },
                                getContentAnchorEl: null,
                                anchorEl: menuevbi,
                                keepMounted: true,
                                open: Boolean(menuevbi),
                                onClose: handleCloseMenuEvbi,
                            }}
                            onClick={handleOpenMenuEvbi}
                            style={{
                                width: 150,
                                borderRadius: '10px',
                                top: 0,
                                zIndex: 5000000,
                            }}
                            displayEmpty

                        >
                            {ArrayEvbis.map((evbi) => (
                                <MenuItem key={evbi.id} value={evbi.id}>
                                    <Checkbox checked={selectedEvbisTemp.includes(evbi.id)} />
                                    <ListItemText primary={evbi.name} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                )}
                {selectedFiltertemp.includes('genero') && (
                    <FormControl className={classes.formControl} style={{ width: '100%', borderRadius: '10px', marginLeft: '35px' }}>
                        <InputLabel id="genero-select-label-templates">Filtrar Genero</InputLabel>
                        <Select
                            labelId="genero-select-label-templates"
                            id="genero-select-templates"
                            value={generoTemp}
                            onChange={(e) => setGeneroTemp(e.target.value)}
                            style={{ width: '100%' }}
                        >
                            {Generos.map((genero) => (
                                <MenuItem key={genero.value} value={genero.value}>
                                    {genero.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                )}
                {selectedFiltertemp.includes('altura') && (
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <FormControl className={classes.formControl} style={{ width: '48%', borderRadius: '10px' }}>
                            <InputLabel htmlFor="altura-minima" style={{ fontSize: '0.8rem' }}>Altura Mínima (cm)</InputLabel>
                            <Input
                                id="altura-minima"
                                type="number"
                                inputProps={{ min: 0, max: 999, maxLength: 3 }}
                                value={alturaMinimaTemp}
                                onChange={(e) => {
                                    let value = e.target.value;
                                    if (value.length <= 3) {
                                        setAlturaMinimaTemp(value);
                                    }
                                }}
                            />
                        </FormControl>
                        <FormControl className={classes.formControl} style={{ width: '48%', borderRadius: '10px' }}>
                            <InputLabel htmlFor="altura-maxima" style={{ fontSize: '0.8rem' }}>Altura Máxima (cm)</InputLabel>
                            <Input
                                id="altura-maxima"
                                type="number"
                                inputProps={{ min: 0, max: 999, maxLength: 3 }}
                                value={alturaMaximaTemp}
                                onChange={(e) => {
                                    let value = e.target.value;
                                    if (value.length <= 3) {
                                        setAlturaMaximaTemp(value);
                                    }
                                }}
                            />
                        </FormControl>
                    </div>
                )}
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '9%', }}>
                {selectedFiltertemp.includes('edad') && (
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <FormControl className={classes.formControl} style={{ width: '45%', borderRadius: '10px' }}>
                            <InputLabel htmlFor="edad-minima">Edad Mínima</InputLabel>
                            <Input
                                id="edad-minima"
                                type="number"
                                inputProps={{ min: 18, max: 99, maxLength: 2 }}
                                value={edadMinimaTemp}
                                onChange={(e) => {
                                    let value = e.target.value;
                                    if (value.length <= 2) {
                                        setEdadMinimaTemp(value);
                                    }
                                }}
                            />
                        </FormControl>
                        <FormControl className={classes.formControl} style={{ width: '45%', borderRadius: '10px' }}>
                            <InputLabel htmlFor="edad-maxima">Edad Máxima</InputLabel>
                            <Input
                                id="edad-maxima"
                                type="number"
                                inputProps={{ min: 18, max: 99, maxLength: 2 }}
                                value={edadMaximaTemp}
                                onChange={(e) => {
                                    let value = e.target.value;
                                    if (value.length <= 2) {
                                        setEdadMaximaTemp(value);
                                    }
                                }}
                            />
                        </FormControl>
                    </div>
                )}
                {selectedFiltertemp.includes('peso') && (
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <FormControl className={classes.formControl} style={{ width: '45%', borderRadius: '10px' }}>
                            <InputLabel htmlFor="peso-minimo">Peso Mínimo</InputLabel>
                            <Input
                                id="peso-minimo"
                                type="number"
                                inputProps={{ min: 0, max: 999, maxLength: 3 }}
                                value={pesoMinimoTemp}
                                onChange={(e) => {
                                    let value = e.target.value;
                                    if (value.length <= 3) {
                                        setPesoMinimoTemp(value);
                                    }
                                }}
                            />
                        </FormControl>
                        <FormControl className={classes.formControl} style={{ width: '45%', borderRadius: '10px' }}>
                            <InputLabel htmlFor="peso-maximo">Peso Máximo</InputLabel>
                            <Input
                                id="peso-maximo"
                                type="number"
                                inputProps={{ min: 0, max: 999, maxLength: 3 }}
                                value={pesoMaximoTemp}
                                onChange={(e) => {
                                    let value = e.target.value;
                                    if (value.length <= 3) {
                                        setPesoMaximoTemp(value);
                                    }
                                }}
                            />
                        </FormControl>
                    </div>
                )}
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '9%', }}>
                {selectedFiltertemp.includes('imc') && (
                    <FormControl className={classes.formControl} style={{ width: '100%', borderRadius: '10px' }}>
                        <InputLabel id="imc-select-label-templates">Filtrar IMC</InputLabel>
                        <Select
                            labelId="imc-select-label-templates"
                            id="imc-select-templates"
                            value={IMCTemp}
                            onChange={(e) => setIMCTemp(e.target.value)}
                            style={{ width: '100%' }}
                        >
                            {IMCS.map((IMC) => (
                                <MenuItem key={IMC.value} value={IMC.value}>
                                    {IMC.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                )}
                {selectedFiltertemp.includes('pgc') && (
                    <FormControl className={classes.formControl} style={{ width: '100%', borderRadius: '10px' }}>
                        <InputLabel id="pgc-select-label-templates">Filtrar PGC</InputLabel>
                        <Select
                            labelId="pgc-select-label-templates"
                            id="pgc-select-templates"
                            value={PGCTemp}
                            onChange={(e) => setPGCTemp(e.target.value)}
                            style={{ width: '100%' }}
                        >
                            {PGCS.map((PGC) => (
                                <MenuItem key={PGC.value} value={PGC.value}>
                                    {PGC.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                )}
                {selectedFiltertemp.includes('presion') && (
                    <FormControl className={classes.formControl} style={{ width: '100%', borderRadius: '10px' }}>
                        <InputLabel id="presion-select-label-templates">Filtrar Presion</InputLabel>
                        <Select
                            labelId="presion-select-label-templates"
                            id="presion-select-templates"
                            value={presionTemp}
                            onChange={(e) => setPresionTemp(e.target.value)}
                            style={{ width: '100%' }}
                        >
                            {Presiones.map((presion) => (
                                <MenuItem key={presion.value} value={presion.value}>
                                    {presion.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                )}
            </div>
        </div >
    );


    return (
        <Modal
            className={classes.modal}
            open={open}
            onClose={handleClosed}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Fade in={open}>
                <div className={`${classes.paper} ${classes.centeredContent}`}>
                    <IconButton className={classes.closeIcon} onClick={handleClosed}>
                        <CloseIcon style={{ color: primaryColor }} />
                    </IconButton>
                    <FormControl className={classes.formControl} style={{ width: '100%', borderRadius: '10px' }}>
                        <InputLabel id="filter-select-label-templates">Filtrar por</InputLabel>
                        <Select
                            multiple
                            id="filter-menu"
                            value={selectedFiltertemp}
                            onChange={(e) => handleSelectFilters(e.target.value)}
                            renderValue={(selected) => selected.join(', ')}
                            MenuProps={{
                                anchorOrigin: {
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                },
                                transformOrigin: {
                                    vertical: 'top',
                                    horizontal: 'left',
                                },
                                getContentAnchorEl: null, // Remove this line if not needed
                                anchorEl,
                                keepMounted: true,
                                open: Boolean(anchorEl),
                                onClose: handleCloseMenu, // Close the menu when an option is selected
                            }}
                            onClick={handleOpenMenu} // This will open the menu on click
                            style={{
                                width: '100%',
                                borderRadius: '10px',
                                top: 0, // Adjust top position as needed
                                zIndex: 5000000,
                            }}
                            displayEmpty // Show an empty value
                            placeholder="Seleccione un filtro" // Placeholder text
                        >
                            {['Evbi', 'genero', 'altura', 'edad', 'peso', 'imc', 'pgc', 'presion'].map((filter) => (
                                <MenuItem key={filter} value={filter}>
                                    <Checkbox checked={selectedFiltertemp.includes(filter)} />
                                    <ListItemText primary={filter} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    {content}
                    <Button onClick={handleFiltrar} style={{ color: 'white', backgroundColor: primaryColor, borderRadius: '10px', width: '48%', marginTop: '11px', marginLeft: '18px' }} className='box selected'>
                        Filtrar
                    </Button>
                </div>
            </Fade>
        </Modal>
    );
};

export default FilterModal;
